var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.022 1.128a.75.75 0 1 0-1.044 1.076l8.296 8.045H.875a.75.75 0 0 0 0 1.5h17.4l-8.297 8.045a.75.75 0 1 0 1.044 1.077l9.625-9.333a.75.75 0 0 0 .228-.536v-.003a.75.75 0 0 0-.229-.539l-9.624-9.332Z",
    fill: "#273943"
  })));
};
export default SvgNext;